<div class="d-flex" style="font-weight: 500;">
  <div *ngIf="aggregatedData?.locations" container="body"
       ngbTooltip="{{!showCaption ? ('lang.globals.locations' | translate) : null}}"
       class="px-2 border-dashed-right stableWidth d-flex justify-content-between">
        <span><ng-container *ngIf="showCaption">{{'lang.globals.locations' | translate}}</ng-container>
      <sb-icon class="ml-1" icon="location" [dualColor]="true"></sb-icon>
    </span>
    <span>{{aggregatedData?.locations | sbNumberFormat}}</span>
  </div>
  <div *ngIf="aggregatedData?.devices" container="body"
       ngbTooltip="{{!showCaption ? ('lang.globals.devices' | translate) : null}}"
       class="px-2 border-dashed-right stableWidth d-flex justify-content-between">
        <span> <ng-container *ngIf="showCaption"> {{'lang.globals.devices' | translate}}</ng-container>
      <sb-icon class="ml-1" icon="playerOnline" [dualColor]="true"></sb-icon>
    </span>
    <span>{{aggregatedData?.devices | sbNumberFormat}}</span>
  </div>
  <div *ngIf="aggregatedData?.channels" container="body"
       ngbTooltip="{{!showCaption ? ('lang.globals.channels' | translate) : null}}"
       class="px-2 border-dashed-right stableWidth d-flex justify-content-between">
        <span> <ng-container *ngIf="showCaption"> {{'lang.globals.channels' | translate}}</ng-container>
      <sb-icon class="ml-1" icon="stele" [dualColor]="true"></sb-icon>
    </span>
    <span>{{aggregatedData?.channels | sbNumberFormat}}</span>
  </div>
  <div *ngIf="aggregatedData?.screens" container="body"
       ngbTooltip="{{!showCaption ? ('lang.globals.screens' | translate) : null}}"
       class="pl-2 stableWidth d-flex justify-content-between">
        <span><ng-container *ngIf="showCaption">{{'lang.globals.screens' | translate}}</ng-container>
      <sb-icon class="ml-1" icon="screen" [dualColor]="true"></sb-icon>
    </span>
    <span>{{aggregatedData?.screens | sbNumberFormat}}</span>
  </div>
</div>
